// GalleryData.jsx
import "./Gallery.css";
import React from "react";

const GalleryData = ({ renderImages, galleryData }) => {
  const infoDisplay = (e) => {
    if (e.target.classList.contains("galleryImg")) {
      e.target.parentNode.querySelector(".imgInfo")?.classList.remove("hidden");
    }
  };
  const infoHide = (e) => {
    if (e.target.classList.contains("galleryImg")) {
      e.target.parentNode.querySelector(".imgInfo")?.classList.add("hidden");
    }
  };

  return (
    <>
      {renderImages.map((row, rowIndex) => (
        <div className="row justify-content-center m-2" key={rowIndex}>
          {row.map((image, colIndex) => {
            const meta = galleryData?.[image];
            if (!meta) {
              // Optional: console.warn for debugging
              // console.warn(`Missing galleryData for key: ${image}`);
              return null; // skip unknown key
            }
            return (
              <div
                className="col-6 col-md-4 col-lg-3 d-flex justify-content-center align-items-center mb-4"
                key={`${rowIndex}-${colIndex}-${image}`}
              >
                <div className="galleryCard" onMouseEnter={infoDisplay} onMouseLeave={infoHide}>
                  <img className="galleryImg" src={`/images/Gallery/${image}.jpg`} alt={image} />
                  <div className="imgInfo hidden p-3">
                    <div>{`${meta[0]}, ${meta[1]}`}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
};

export default GalleryData;
